/**
 * @param {object | null} session
 * @param {boolean} wantBlob
 */
export async function finalizeDictationSession(session, wantBlob) {
  if (!session) return undefined

  cancelAnimationFrame(session.rafId)
  session.rafId = 0

  const blob = await new Promise((resolve) => {
    const { recorder, chunks } = session
    if (!recorder || recorder.state === 'inactive') {
      chunks.length = 0
      resolve(undefined)
      return
    }
    recorder.onstop = () => {
      if (!wantBlob || chunks.length === 0) {
        chunks.length = 0
        resolve(undefined)
        return
      }
      const type = recorder.mimeType || 'audio/webm'
      const b = new Blob(chunks, { type })
      chunks.length = 0
      resolve(b)
    }
    recorder.stop()
  })

  session.stream.getTracks().forEach((t) => t.stop())
  await session.ctx.close().catch(() => {})
  return blob
}

export function stopDictationSession(session) {
  if (!session) return
  cancelAnimationFrame(session.rafId)
  if (session.recorder && session.recorder.state !== 'inactive') {
    session.recorder.onstop = null
    session.recorder.stop()
  }
  session.stream.getTracks().forEach((t) => t.stop())
  session.ctx.close().catch(() => {})
}
